import { Header } from '../../../components/header';
import { useTranslation } from 'react-i18next';
import { useState, useMemo } from 'react';
import Sidebar from '../../../components/Sidebar';
import TimesheetTabs from './components/TimesheetTabs';
import TimesheetCreation from './components/TimesheetCreation';
import TimesheetReports from './components/TimesheetReports';
import WorkedHours from './components/WorkedHours';
import './timeSheetsPage.scss';
import { INVOZIO_BLOB_BASE } from '../../../constant/video-url-import.constant';

const videoUrlEn = `${INVOZIO_BLOB_BASE}/how_to_use_timesheet_en.mp4`
const videoUrlSv = `${INVOZIO_BLOB_BASE}/how_to_use_timesheet_sv.mp4`

const videoCameraIcon = (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M15 10L20 7V17L15 14V10Z" stroke="#6750b8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        <rect x="3" y="7" width="12" height="10" rx="2" stroke="#6750b8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
);

const playArrowIcon = (
    <svg width="9" height="11" viewBox="0 0 9 11" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0.5 1L8.5 5.5L0.5 10V1Z" fill="#6750b8" stroke="#6750b8" strokeWidth="0.5" strokeLinejoin="round"/>
    </svg>
);

function TimeSheetsPage() {
    const { t } = useTranslation();
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const [activeTab, setActiveTab] = useState('creating-timesheet');
     const lang = new URLSearchParams(window.location.search).get('lang') || 'en-us';
    const isSv = lang === 'en-us' ? false : true
    const handleButtonClick=() =>{
      window.open(isSv ? videoUrlSv : videoUrlEn, '_blank', 'noopener,noreferrer');
    }

    const tabs = useMemo(() => [
        { key: 'creating-timesheet', label: t('CREATING_TIMESHEET') },
        { key: 'reports', label: t('REPORTS') },
        { key: 'worked-hours', label: t('WORKED_HOURS') }
    ], [t]);

    const renderContent = useMemo(() => {
        switch (activeTab) {
            case 'creating-timesheet':
                return <TimesheetCreation />;
            case 'reports':
                return <TimesheetReports />;
            case 'worked-hours':
                return <WorkedHours />;
            default:
                return <TimesheetCreation />;
        }
    }, [activeTab]);

    return (
        <div className="dashboard-page">
            <div className="dashboard-layout">
                <Sidebar
                    activeItemId='timesheets-invoice'
                    footer={null}
                    onClose={() => setIsSidebarOpen(false)}
                    className={`dashboard-sidebar ${isSidebarOpen ? 'sidebar-open' : ''}`}
                />
                <div className="dashboard-main-content">
                    <Header
                        setIsSidebarOpen={setIsSidebarOpen}
                    />
                    <div className='timesheet-page-container'>
                        <div
                            className='tutorial-banner'
                            onClick={handleButtonClick}
                            role="button"
                            tabIndex={0}
                            onKeyDown={(e) => e.key === 'Enter' && handleButtonClick()}
                        >
                            <div className='tutorial-banner__left'>
                                <div className='tutorial-banner__icon-wrapper'>
                                    {videoCameraIcon}
                                </div>
                                <span className='tutorial-banner__text--desktop'>{t('timeSheetBannerDesktop')}</span>
                                <span className='tutorial-banner__text--mobile'>{t('timeSheetBannerMobile')}</span>
                            </div>
                            <div className='tutorial-banner__action'>
                                <span>{t('timeSheetBannerWatch')}</span>
                                {playArrowIcon}
                            </div>
                        </div>
                        <TimesheetTabs 
                            tabs={tabs}
                            activeTab={activeTab}
                            onTabChange={setActiveTab}
                        />
                        <div className='timesheet-content'>
                            {renderContent}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default TimeSheetsPage;
